<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Download File Logging</v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <!-- Pilih PCH/WS/ALL -->
            <v-form ref="uptd">
            <v-row>
              <v-col cols="6">
                <v-select
                  :items="UPTDS"
                  label="UPTD PSDA"
                  v-model="UPTD"
                  @change="getPCH(UPTD)"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="PCHS"
                  label="PCH"
                  v-model="PCH"
                  return-object
                  @change="getFiles(PCH)"
                ></v-select>
              </v-col>
              <v-dialog
                ref="dialog"
                v-model="modal2"
                :return-value.sync="time"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="6">
                  <v-text-field
                    v-model="dateRangeText"
                    label="Pick Date"
                    class="mt-n6"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    
                  ></v-text-field>
                  </v-col>
                </template>
                <v-date-picker
                  v-if="modal2"
                  v-model="dates"
                  full-width
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modal2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(time);getFiles(PCH)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-row>
            </v-form>
            <!-- Table File -->
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="fileDatum"
                  :items-per-page="5"
                  :calculate-widths="true"
                  item-key="time"
                  class="elevation-1"
                  mobile-breakpoint="350"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                  }"
                  :single-expand="false"
                  show-expand
                >
                <template v-slot:[`item.time`]="{ item }">
                  {{item.time}}
                </template>
                <template v-slot:[`item.id`]="{ item }">
                  <v-btn icon @click="clicked(item)" color="primary">
                    <v-icon>
                      mdi-download
                    </v-icon>
                  </v-btn>
                </template>

                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length">
                    
                  <v-data-table
                    :headers="headerDetail"
                    :items="item.data"
                    :items-per-page="-1"
                    :calculate-widths="true"
                    item-key="time"
                    hide-default-footer
                    mobile-breakpoint="350"
                  >
                    <template v-slot:[`item.time`]="{ item }">
                      {{item.time}}
                    </template>
                    <template v-slot:[`item.Charger`]="{ item }">
                      <span v-if="item.Charger==='ON'">
                        <v-chip
                          color="success darken-1"
                        >
                          ON
                        </v-chip>
                      </span>
                      <span v-else>
                        <v-chip
                          color="error"
                        >
                          OFF
                        </v-chip>
                      </span>
                    </template>

                    <template v-slot:[`item.FullCharger`]="{ item }">
                      <span v-if="item.FullCharger==='ON'">
                        <v-chip
                          color="success darken-1"
                        >
                          ON
                        </v-chip>
                      </span>
                      <span v-else>
                        <v-chip
                          color="error"
                        >
                          OFF
                        </v-chip>
                      </span>
                    </template>

                    <template v-slot:[`item.Rain`]="{ item }">
                      <span v-if="item.Rain==='YES'">
                        <v-chip
                          color="success darken-1"
                        >
                          YES
                        </v-chip>
                      </span>
                      <span v-else>
                        <v-chip
                          color="error"
                        >
                          NO
                        </v-chip>
                      </span>
                    </template>
                    
                  </v-data-table>
                  </td>
                </template>

                </v-data-table>
                <v-dialog
                  v-model="dialog"
                  max-width="600"
                >
                  <v-card>
                    <v-toolbar
                      color="primary text-h6"
                      dark
                    >{{ PCH.text }}
                    <v-spacer></v-spacer>
                    
                    </v-toolbar>
                    <v-card-actions>
                      <download-csv
                        class   = "btn btn-default"
                        :data   = "downloadData"
                        :name    = "csvTitle"
                        separator-excel
                        :labels  = "labelsCSV">
                        <v-btn class="float-start mb-2" color="primary" text><v-icon left>mdi-download</v-icon>Download</v-btn>
                      </download-csv>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "../firebase/db.js"
import moment from 'moment'
import csvtojson from 'csvtojson'
// import { Bar } from 'vue-chartjs/legacy'

// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  export default {
    name: 'DataPage',
    // components: { Bar },

    data: () => ({
      UPTDS:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
      UPTD:null,
      PCHS:[],
      PCH:{
        text:'',
        value:null
      },
      Files:[],
      headers: [
        {
          text: 'Waktu',
          align: 'start',
          value: 'time',
        },
        { text: 'Download', value: 'id'},
        { text: '', value: 'data-table-expand' },
      ],
      headerDetail: [
        {
          text: 'Waktu',
          align: 'start',
          value: 'Time',
        },
        { text: 'Accumulated Daily', value: 'AccumulatedDaily'},
        { text: 'Baterai (V)', value: 'Baterai' },
        { text: 'Charger', value: 'Charger' },
        { text: 'Full Charge', value: 'FullCharger' },
        { text: 'Rain', value: 'Rain' },
      ],
      time:[],
      devices:[],
      data:[],
      loadingData: true,
      offset:0,
      File:null,
      station:null,
      dialog:false,
      ID:null,
      fileData: [],
      timeDialog: null,
      modal2: false,
      dates:['2022-07-20','2022-07-27'],
      // loadingData: true,
      tab: null,
      items: [
        'Grafik', 'Tabel',
      ],
      labels:[],
      datasets:[],
      csvTitle:null,
      labelsCSV:{
        Time: 'Time',
        AccumulatedDaily: 'Accumulated Daily(mm)',
        Baterai: 'Baterai(V)',
        Charger: 'Charger',
        FullCharger: 'Full Charger',
        Rain: 'Rain',
      },
      fileDatum:[],
      downloadData:[],
    }),
    async mounted () {
      let loader = this.$loading.show()
      if (localStorage.getItem("role")=='Petugas') {
        let device = localStorage.getItem('device')
        this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
      }
      const date=new Date();
      const today = Date.now()/1000;
      this.dates=[moment.unix(today-604800).utcOffset(this.offset).format("YYYY-MM-DD"),moment.unix(today).utcOffset(this.offset).format("YYYY-MM-DD")],
      this.offset=date.getTimezoneOffset()/(-60)

      let setByLocation=false
      await db.collection('roleSetting').doc(localStorage.getItem("role")).get().then((doc)=> {
        setByLocation=doc.data().location
      })
      if (setByLocation) {
        this.UPTDS=[localStorage.getItem('location')]
        this.UPTD=localStorage.getItem('location')
        this.getPCH(this.UPTD)
      }

      if (localStorage.getItem('location')=='MARNOV') {
        this.UPTDS.push('MARNOV')
      }
      

      

      // reportDataRef.orderBy("time","desc").onSnapshot((collectionSnapshot) => {
      //   let i=0
      //   this.historical=[]
      //   collectionSnapshot.forEach((doc) => {
      //     this.historical.push({curah:doc.data().rain, tenggang:doc.data().expire, quota: doc.data().kuota, timeReport: doc.data().time})
      //     this.historical[i].id=doc.id
      //     i++
      //   });
      //   db.collection('device').onSnapshot((collectionSnapshot) => {
      //     i=0
      //     this.devices=[]
      //     collectionSnapshot.forEach((doc) => {
      //       this.devices.push(doc.data())
      //       this.devices[i].id=doc.id
      //       i++
      //     });
          
      //     for (i=0;i<this.historical.length;i++) {
      //       for (let j=0;j<this.devices.length;j++) {
      //         if (this.historical[i].id==this.devices[j].id) {
      //           this.historical[i].location=this.devices[j].location
      //           this.historical[i].station=this.devices[j].station
      //           this.historical[i].phoneNumber = this.devices[j].phoneNumber
      //           this.historical[i].macAddress = this.devices[j].macAddress
      //           break;
      //         }
      //       }
      //     }
      //     this.data=this.historical
      //     loader.hide()
      //   })
      // })
      loader.hide()
    },
    computed: {
      dateRangeText () {
        let dateRange=[]
        if (this.dates[0]>this.dates[1]) {
          dateRange[0]=this.dates[1]
          dateRange[1]=this.dates[0]
        } else {
          dateRange[0]=this.dates[0]
          dateRange[1]=this.dates[1]
        }
        return dateRange.join(' ~ ')
      },
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      clicked(item) {
        this.dialog=true
        this.csvTitle=`LOG_${this.PCH.text}-${item.time}.csv`
        let i = this.fileDatum.findIndex((e)=> e.time == item.time)
        this.downloadData=this.fileDatum[i].data
      },
      async getPCH(UPTD) {
        this.PCHS=[]
        await db.collection('device').where('location','==',UPTD).get().then((docs)=> {
          docs.forEach((doc)=> {
            this.PCHS.push({value:doc.id, text:doc.data().station})
          })
        })
      },
      async getFiles(PCH) {
        console.log(PCH.value)
        if (this.dates[0]>this.dates[1]) {
          let temp=this.dates[0]
          this.dates[0]=this.dates[1]
          this.dates[1]=temp
        }
        let start = (moment(this.dates[0], "YYYY-MM-DD").valueOf());
        let end = (moment(this.dates[1], "YYYY-MM-DD").valueOf()+86400000);
        console.log (start)
        console.log(end)
        var reportRef = db.collection('files').doc(PCH.value).collection('data')
        reportRef.orderBy("time","desc").where("time", ">=", start).where("time", "<=", end).onSnapshot((collectionSnapshot) => {
          this.fileData=[]
          this.fileDatum=[]
          collectionSnapshot.forEach((doc) => {
            this.fileData.push({time: moment.unix(doc.data().time/1000).utcOffset(this.offset).format("DD MMM YYYY HH:mm"), data:doc.data().data})
            csvtojson()
            .fromString(doc.data().data)
            .then((csvRow)=>{ 
                this.fileDatum.push({time: moment.unix(doc.data().time/1000).utcOffset(this.offset).format("DD MMM YYYY HH:mm"),data:csvRow})
            })
          });
          console.log(this.fileData)
          // this.loadingData=false
        })
      },
    },
  }
</script>
